export default "__VITE_ASSET__C759vDp0__"